import cx from 'classnames'

import { CircularProgress } from '../../shared/NarusMaterial'

import styles from './button.module.css'

export function Button ({ label, disabled, loading }) {
  return (
    <div className={styles.button_wrapper}>
      <button
        className={cx(styles.button, {
          [styles.active]: loading
        })}
        disabled={disabled || loading}
        type='submit'
      >
        {label}
      </button>
      {loading && (
        <div className={styles.spinner}>
          <CircularProgress
            className='small'
            style={{
              width: '20px',
              height: '20px'
            }}
            color='white'
          />
        </div>
      )}
    </div>
  )
}
